(function () {
  angular.module('7Shop.GoogleAnalytics', [])
    .run(function (ShopEnvironment, googleAnalyticsService) {
      if (!ShopEnvironment.isDebugMode()) {
        googleAnalyticsService.init();
      }
    });
})();
